<div class="page-header">
	<h1 class="page-header__title">{{ 'relation-type.title' | translate }}</h1>
	<div class="page-header__actions">
		<a
			claimDirective
			[claims]="[
				{
					claimType: ClaimTypes.RelationType,
					claimValues: [ClaimValues.Create]
				}
			]"
			routerLink="/relatie-typen/toevoegen"
			nz-button
			nzType="primary">
			{{ 'common.add' | translate }}
			<i class="fa-regular fa-plus"></i>
		</a>
	</div>
</div>

<app-relation-type-overview-table
	[data]="(tableData$ | async)!"
	(delete)="onDeleteConfirm($event)"
	(onQueryParamsChange)="onQueryParamsChange($event)"
	(changeSequence)="onSequenceChange($event)"
	(onResetOverview)="onResetOverview()" />
